<template>
    <section class="uploadFile" role="uploadFiles">
        <b-field>
            <b-upload
                v-model="file"
                expanded
                class="file-label"
                :accept="extensionAccept"
                required
                :validationMessage="
                    `Por favor seleccione un archivo ${extensionAccept}`
                "
                drag-drop
                :disabled="isLoading"
                @input="uploadFile()"
            >
                <section class="section">
                    <div class="content has-text-centered">
                        <p>
                            <b-icon
                                icon="upload"
                                type="is-primary"
                                size="is-large"
                            >
                            </b-icon>
                        </p>
                        <p style="margin-bottom: 0">
                            Haz click aquí o suelta tu {{ fileName }}
                            en esta área
                        </p>
                        <p class="has-text-grey-light">
                            Solo puedes ingresar un archivo a la vez, formato
                            {{ messageFormat }}
                        </p>
                    </div>
                </section>
            </b-upload>
        </b-field>
        <div class="tags">
            <span v-if="file" class="tag is-primary">
                {{ file.name }}
                <button
                    class="delete is-small"
                    type="button"
                    @click="deleteFile()"
                ></button>
            </span>
        </div>
    </section>
</template>

<script>
export default {
    name: "uploadFile",
    data() {
        return {
            file: null,
        };
    },
    props: {
        extensionAccept: {
            type: String,
            required: true,
            default: () => ".xlsx",
        },
        messageFormat: {
            type: String,
            required: true,
            default: () => "XLSX",
        },
        fileName: {
            type: String,
            required: true,
            default: () => "archivo",
        },
        isLoading: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    methods: {
        deleteFile() {
            this.file = null;
            this.$emit("removedFile");
        },
        uploadFile() {
            this.$emit("uploaded", this.file);
        },
    },
};
</script>
